<div class="flex flex-col h-[80vh]">
  <section class="h-[90%]">
    @if (!showStepTwo) {
      <p class="sm:mb-6 font-semibold text-xl">
        Recommended <span class="font-weight-bold-blue">attachments</span> for
        <span [matTooltip]="data?.form_name.length > 41 ? data.form_name : ''"> {{ data?.form_name | truncateStrPipe : 41 }} </span>
      </p>
    }
    <div
      style="
        overflow: auto !important;
        height: auto !important;
        max-height: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
      [ngClass]="{ 'border rounded-xl border-solid border border-[#53565B38]': !showStepTwo }"
      class="bg-[#fff] shadow-none mb-3 h-auto"
      >
      <div class="flex flex-column">
        <div style="top: 0px; display: flex; flex-direction: column; background: white; z-index: 1">
          @if (!showStepTwo) {
            <div class="flex flex-row px-6 pt-3">
              @for (reminder of reminderList; track reminder; let i = $index) {
                <div
                  class="h-1.5 w-14 rounded-[40px] mr-1"
              [ngClass]="{
                'bg-[#25508E]': i == currentStep || reminder.status == 'complete',
                'bg-[#7E9BD4]': i < currentStep && reminder.status != 'complete',
                'bg-[#DCDCDC]': i > currentStep && reminder.status != 'complete'
              }"
                ></div>
              }
            </div>
          }
          @if (!showStepTwo) {
            @for (reminder of reminderList; track reminder; let i = $index) {
              @if (i == currentStep) {
                <div class="flex flex-row justify-between">
                  <p class="px-6 pt-2 pb-2 sm:mb-0  font-bold" style="font-size: 16px;">
                    {{ reminder.description }}
                  </p>
                  <p
                    style="margin-right: 24px !important"
                    [matMenuTriggerFor]="addMenu"
                    #menuAdd="matMenuTrigger"
                    (menuOpened)="(menuAdd.menuOpen)"
                    (menuClosed)="(menuAdd.menuOpen)"
                    class="m-0 text-sm font-bold text-[#25508e]"
                    >
                    <mat-icon style="position: relative; top: 6px">add</mat-icon> Add Attachment
                  </p>
                  <mat-menu #addMenu="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
                    <div class="upload-file">
                      <input type="file" (change)="onFileChanged($event, true)" multiple #fileInput style="display: none" />
                      <button mat-menu-item (click)="fileInput.click()" class="h-8 font-semibold text-sm">
                        <img src="assets/images/upload-file.svg" />
                        Upload File
                      </button>
                    </div>
                    <div class="upload-folder">
                      <input
                        type="file"
                        name="files"
                        accept=".iso"
                        webkitdirectory
                        mozdirectory
                        directory
                        multiple
                        id="files"
                        (change)="onFileChanged($event, false)"
                        #folderInput
                        style="display: none"
                        />
                        <button mat-menu-item (click)="folderInput.click()" class="h-8 font-semibold text-sm">
                          <span
                            style="position: relative; top: 4px; left: -4px; color: #25508e; font-size: 20px"
                            class="material-icons material-icons-round common-menuitem-icon"
                            >folder_open</span
                            >Upload Folder
                          </button>
                        </div>
                      </mat-menu>
                    </div>
                  }
                }
              }
            </div>
            <div
              class="flex flex-col mx-6 mb-1.5"
              [style.overflow]="attachedFiles.length ? 'auto' : 'auto'"
              [ngStyle]="{ height: showStepTwo ? 'auto' : 'auto' }"
              >
              @if (attachedFiles_loading) {
                <div class="loader-container">
                  @for (item of loadingItems; track item) {
                    <div>
                      <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
                        <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px; width: 194px; height: 112px">
                          <div class="ph-col-12" style="padding: 0px !important">
                            <div class="ph-row">
                              <div class="ph-col-12" style="height: 104px !important"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (!showStepTwo && attachedFiles.length == 0 && !attachedFiles_loading) {
                <div>
                  <div
                    (drop)="dragged($event)"
                    (dragenter)="allowDrop($event)"
                    (dragleave)="dropleave($event)"
                    (click)="fileInput.click()"
                    appDragDrop
                    class="h-15 mb-4 mt-4 bg-[#EBF0FA] border-dashed rounded-sm border-2 text-center"
                    >
                    <img src="assets/images/upload-image-icon-form.svg" class="bg-[#FFFFFF] rounded-full mt-[6px] mb-[6px]" />
                    @if (!hideAttachmentAvailableSection) {
                      <p class="text-[#515765] text-xs font-bold">Drag and drop to upload files</p>
                    }
                    @if (hideAttachmentAvailableSection) {
                      <p class="text-[#515765] text-xs font-bold">
                        <span style="color: #25508e">Upload</span> a file from your computer
                      </p>
                    }
                    <input hidden type="file" #fileInput multiple (change)="uploadFile($event)" />
                  </div>
                  @for (reminder of reminderList; track reminder; let i = $index) {
                    @if (i == currentStep) {
                      <ng-container class="flex flex-row justify-between">
                        <mat-checkbox class="automatic-form-checkbox checkbox-with-label" [(ngModel)]="selectDOntAdd">
                          <mat-label class="automtic-form-desing-lable m-0"> I don’t want to attach {{ reminder.description }} </mat-label>
                        </mat-checkbox>
                      </ng-container>
                    }
                  }
                </div>
              }
              @if (!showStepTwo && attachedFiles.length) {
                <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                  @for (file of attachedFiles; track file; let i = $index) {
                    <div style="width: 196px" class="flex mb-[16px] mr-[16px]">
                        <div
                          class="flex justify-between flex-col border border-[#d3dce8] bg-[#FFFFFF] w-full h-[112px] box-border"
                          style="border-radius: 8px 8px 0px 0px"
                          >
                          <div class="flex justify-between flex-col">
                            <div class="flex flex-col">
                              <div style="left: 0px; top: 0px; height: 0px; text-align: end; z-index: 1"></div>
                              @if (file.status == 'Done') {
                                <file-preview-setup
                                  [file]="file"
                                  style="height: 68px !important"
                                  [IconName]="file | iconName"
                                  [currentuserId]="currentuserId"
                                  #fileExtensionComponentchild
                                  >
                                </file-preview-setup>
                              }
                              @if (file.status != 'Done') {
                                <div style="height: 68px !important"></div>
                              }
                              @if (file.status != 'Done') {
                                <mat-progress-bar mode="determinate" [value]="file.progressbar"></mat-progress-bar>
                              }
                            </div>
                            <div style="background: white; z-index: 1; border-radius: 0px 0px 8px 8px" class="flex justify-between border border-[#d3dce8]">
                              <p style="max-width: 76%" class="text-[##010b18] leading-9 font-bold text-sm pl-[12px]">
                                {{ file.display_file_name?.length > 14 ? file.display_file_name?.slice(0, 14) + '...' : file.display_file_name?.slice(0, 14) }}
                              </p>
                              @if (file.status == 'Done') {
                                <div class="popup-menu">
                                  <button
                                    class="more-vote-btn"
                                    mat-icon-button
                                    [matMenuTriggerFor]="menuItem"
                                    (click)="$event.stopPropagation()"
                                    [disableRipple]="true"
                                    >
                                    <span class="material-icons" style="position: relative; left: 12px">more_vert</span>
                                  </button>
                                  <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                                    <button
                                      style="width: 185px"
                                      (click)="getUrl(file, i, file.name)"
                                      mat-menu-item
                                      class="text-[#000] leading-3 text-sm font-normal"
                                      >
                                      <img style="margin: 0 9px" src="assets/images/delete-icon-btn.svg" />
                                      View
                                    </button>
                                    <button
                                      style="width: 185px"
                                      (click)="deleteAttachmentTOReminder(i, file.id, file.display_file_name)"
                                      mat-menu-item
                                      class="text-[#000] leading-3 text-sm font-normal"
                                      >
                                      <span
                                        style="margin: 0 9px; position: relative; top: 4px"
                                        class="text-[#25508e] material-icons material-icons-round menuitem-icon"
                                        >delete</span
                                        >
                                        Remove
                                      </button>
                                    </mat-menu>
                                  </div>
                                }
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </div>
                      }
                      <!-- <attached-file-section
                      (someEvent)="getAllFIle($event)"
                      style="display: flex; flex-wrap: wrap;"
                      [attachedFiles]="attachedFiles"
                      >
                    </attached-file-section> -->
                  </div>
                }
              </div>
              @if (showStepTwo) {
                <div class="loader-container" style="flex-direction: column">
                  @for (item of loadingItems; track item) {
                    <div>
                      <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
                        <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
                          <div class="ph-col-12" style="padding: 0px !important">
                            <div class="ph-row">
                              <div class="ph-col-12"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            @if (!showStepTwo && reminderList?.length > 1) {
              <div style="height: 36px !important;max-height: 36px !important;min-height: 36px !important;"  class="bg-[#EBF0FA] rounded-b-xl flex items-start justify-between px-6 h-12">
                <div style="min-width: 148px">
                  @if (!(currentStep == 0)) {
                    <button
                      (click)="previousReminder()"
                      class=" w-auto mt-1.5 px-6 py-0 mb-0  app__btn--primary"
                      type="submit"
                      style="background: transparent; border: 1px solid; font-weight: 600; color: #25508e;height: 26px !important;"
                      (click)="previousReminder()"
                      >
                      <span class="material-icons text-base ml-[4px] "> arrow_back</span> Previous
                    </button>
                  }
                </div>
                @if ((attachedFiles.length || selectDOntAdd) && !(currentStep == reminderList.length - 1)) {
                  <button
                    class=" w-auto mt-1.5 px-6 py-0 mb-0  app__btn--primary"
                    style="height: 26px !important;"
                    type="submit"
                    (click)="nextReminder()"
                    >
                    Next <span class="material-icons text-base ml-[4px] "> arrow_right_alt</span>
                  </button>
                }
              </div>
            }
          </div>
          @if (!showStepTwo && !hideAttachmentAvailableSection) {
            <div
              class="flex flex-row flex-wrap overflow-hidden shadow-none rounded-xl border-solid border border-[#53565B38]"
              style="overflow: auto !important; height: auto !important; max-height: 36%"
              >
              <div class="flex flex-row justify-between w-full h-10 sticky top-0 bg-white z-50 px-6 py-1">
                <div>
                  <p class="text-[#53565B] text-base mb-0 font-semibold"  style="line-height: 32px !important">Available Files · {{ is_file_loading ? '': files.length }}</p>
                </div>
                <div>
                  <div class="app__centered-item w-full h-full px-5 border-solid border border-[#53565B38]">
                    <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
                    <input
                      class="h-full w-full ml-2 border-none outline-none text-[13px] italic"
                      type="text"
                      [(ngModel)]="searchText"
                      placeholder="Search attachments"
                      (input)="onInputChange($event.target.value)"
                      />
                    </div>
                  </div>
                </div>
                <div class="example-list overflow-auto p-6 mb-6" style="width: 100%; display: flex; flex-wrap: wrap; height: -webkit-fill-available">
                  @for (file of files | filterFileListWithName : searchText; track file; let i = $index) {
                    <div style="width: 196px" class="flex mb-[16px] mr-[16px]">
                      <div
                        style="border-radius: 8px; z-index: 0"
                        (mouseenter)="file.showButton = true"
                        (click)="selectAttachment(file)"
                        (mouseleave)="file.showButton = false"
                        class="flex justify-between flex-col border border-[#d3dce8] bg-[#FFFFFF] w-full h-[112px] box-border"
                        >
                        <div style="z-index: 0" class="flex justify-between flex-col">
                          <div class="flex flex-col" [style.background]="file.showButton ? '#00000060' : ''">
                            <div style="left: 0px; top: 0px; height: 0px; text-align: end; z-index: 1">
                              @if (file.showButton) {
                                <button
                                  class="h-7 w-16 text-[#25508e]"
                                  style="font-size: 14px; font-weight: 600; position: relative; z-index: 0; left: -69px; top: 26px"
                                  >
                                  Select
                                </button>
                              }
                            </div>
                            <file-preview-setup
                              style="height: 69px !important"
                              [file]="file"
                              [IconName]="file | iconName"
                              [currentuserId]="currentuserId"
                              #fileExtensionComponentchild
                              >
                            </file-preview-setup>
                          </div>
                          <div class="flex justify-between border border-[#d3dce8]" style="border-radius: 0px 0px 8px 8px; background: white; z-index: 1">
                            @if (file.status == 'Done') {
                              <p style="max-width: 76%; margin: 0px" class="text-[##010b18] leading-9 font-bold text-sm pl-[12px]">
                                {{ file.file_name?.length > 15 ? file.file_name?.slice(0, 15) + '...' : file.file_name?.slice(0, 15) }}
                              </p>
                            }
                            @if (file.status == 'Done') {
                              <div class="popup-menu">
                                <button
                                  class="more-vote-btn"
                                  (click)="$event.stopPropagation()"
                                  mat-icon-button
                                  [matMenuTriggerFor]="menuItem"
                                  [disableRipple]="true"
                                  >
                                  <span class="material-icons" style="position: relative; left: 12px">more_vert</span>
                                </button>
                                <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                                  <button style="width: 185px" (click)="renameFolder(file, i)" mat-menu-item class="text-[#000] leading-3 text-sm font-normal">
                                    <span
                                      style="margin: 0 9px; position: relative; top: 4px"
                                      class="text-[#25508e] material-icons material-icons-round menuitem-icon"
                                      >edit</span
                                      >
                                      Rename
                                    </button>
                                    <button
                                      style="width: 185px"
                                      (click)="deleteAttachment(i, file.id, file.file_name)"
                                      mat-menu-item
                                      class="text-[#000] leading-3 text-sm font-normal"
                                      >
                                      <span
                                        style="margin: 0 9px; position: relative; top: 4px"
                                        class="text-[#25508e] material-icons material-icons-round menuitem-icon"
                                        >delete</span
                                        >
                                        Delete
                                      </button>
                                    </mat-menu>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div style="visibility: hidden; height: 0px; width: 0px">
                  <form-preview-setup [fId]="data.vault_form_id" [JsonDataExtractedData]="JsonDataExtractedData"> </form-preview-setup>
                </div>
              </section>
              <mat-divider class="mt-6 pr-6"></mat-divider>
              <section class="h-[10%] pr-6 mt-3 flex justify-between">
                <div
      [class]="
        screenWidth >= 480
          ? 'flex items-start justify-between pl-0 pr-0 w-full h-[65px]'
          : 'flex items-start justify-between pl-0 pr-0 w-full h-[65px]'
      "
                  >
                  <button (click)="backForm()" class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2">
                    <span class="flex items-center gap-2 text-[#18191C]"
                      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
                      >
                    </button>
                    <div class="w-[158px]">
                      @if (currentStep == reminderList.length - 1 && (selectDOntAdd || attachedFiles.length)) {
                        <button
                          class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
                          type="submit"
                          (click)="submitReminderForm()"
                          >
                          Continue
                        </button>
                      }
                    </div>
                  </div>
                </section>
              </div>
